import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldPotential = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.1133 4.07031L11.2383 0.789062C10.9922 0.707031 10.7461 0.666016 10.5 0.666016C10.2129 0.666016 9.9668 0.707031 9.7207 0.789062L1.8457 4.07031C1.10742 4.39844 0.65625 5.0957 0.65625 5.875C0.65625 16.457 8.4082 21.625 10.459 21.625C12.5098 21.625 20.3438 16.5391 20.3438 5.875C20.3438 5.0957 19.8516 4.39844 19.1133 4.07031ZM10.5 19.6562C6.48047 18.0156 2.625 12.8477 2.625 5.875L10.5 2.59375L18.375 5.875C18.375 13.0117 14.3145 18.0566 10.5 19.6562ZM8.20312 10.7559C8.03906 10.5918 7.79297 10.4688 7.54688 10.4688C6.97266 10.4688 6.5625 10.9199 6.5625 11.4531C6.5625 11.7402 6.64453 11.9863 6.84961 12.1504L8.81836 14.1191C8.98242 14.3242 9.22852 14.4062 9.51562 14.4062C9.59766 14.4062 9.9668 14.3652 10.2539 14.0371L14.1914 9.44336C14.3555 9.2793 14.4375 9.0332 14.4375 8.82812C14.4375 8.5 14.1914 7.84375 13.4531 7.84375C13.166 7.84375 12.8789 7.92578 12.6738 8.17188L9.43359 11.9863L8.20312 10.7559Z",
		fill: "#949494"
	})]
});
const ForwardRef = forwardRef(SvgIconShieldPotential);
export { ForwardRef as ReactComponent };
